import { appInfo } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-14">
            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 bg-accent-100/70 text-accent-700 text-xs font-medium px-3 py-1 rounded-full mb-4">
                <i className="ri-smartphone-line text-xs"></i>
                <span>移动阅读</span>
              </div>
              <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-4">
                手机阅读
              </h2>
              <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-6">
                {appInfo.desc}
              </p>

              <div className="grid grid-cols-2 gap-3 max-w-md mx-auto lg:mx-0">
                {appInfo.features.map((feat, i) => (
                  <div key={i} className="flex items-center gap-2 text-sm text-foreground-600">
                    <div className="w-6 h-6 flex items-center justify-center shrink-0">
                      <i className="ri-checkbox-circle-fill text-primary-500"></i>
                    </div>
                    <span className="whitespace-nowrap">{feat}</span>
                  </div>
                ))}
              </div>

              <div className="mt-6 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
                <div className="flex items-center gap-2 bg-background-50 border border-background-200/70 rounded-md px-4 py-2.5">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-smartphone-line text-primary-500"></i>
                  </div>
                  <span className="text-sm text-foreground-600 whitespace-nowrap">手机浏览器直接打开</span>
                </div>
                <div className="flex items-center gap-2 bg-background-50 border border-background-200/70 rounded-md px-4 py-2.5">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-qr-code-line text-primary-500"></i>
                  </div>
                  <span className="text-sm text-foreground-600 whitespace-nowrap">扫码即读</span>
                </div>
              </div>
            </div>

            <div className="flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20colorful%20manga%20reading%20app%20interface%20with%20scroll%20reading%20mode%2C%20clean%20UI%20design%2C%20warm%20coral%20accent%20colors%2C%20floating%20on%20a%20soft%20gradient%20background%2C%20minimalist%20product%20presentation%2C%20editorial%20style%2C%20elegant%20lighting%2C%20professional%20product%20photography%2C%20high%20quality&width=600&height=800&seq=app-manga-mockup&orientation=portrait"
                alt="古古漫画网移动端下拉式阅读"
                className="w-56 md:w-72 h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}